import React, { ReactNode } from "react";
import { useFormContext } from "react-hook-form";

interface GeneralCheckboxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name: string;
  label: string | ReactNode;
  value?: number;
  src?: string;
  defaultChecked?: boolean;
  readOnly?: boolean;
  containerClasses?: string;
  inputClasses?: string;
  labelClassname?: string;
}

const GeneralCheckbox: React.FC<GeneralCheckboxProps> = ({
  name,
  label,
  value,
  src,
  defaultChecked = false,
  readOnly = false,
  containerClasses = "",
  inputClasses = "",
  labelClassname = "",
  ...props
}) => {
  const useOptionalFormContext = () => {
    try {
      return useFormContext();
    } catch {
      return null;
    }
  };

  const form = useOptionalFormContext();

  return (
    <div
      className={`flex cursor-pointer items-center gap-3 ${containerClasses}`}
    >
      <input
        type="checkbox"
        id={name}
        defaultChecked={defaultChecked}
        value={value}
        {...form?.register(name)}
        readOnly={readOnly}
        disabled={readOnly}
        className={`h-5 w-5 shrink-0 cursor-pointer ${inputClasses} shadow-md`}
        onChange={props.onChange}
      />
      <div className="flex flex-1 items-center gap-2">
        {src && <img src={src} alt={src} className="h-10 w-10" />}
        <label htmlFor={name} className={`text-primary-text ${labelClassname}`}>
          {label}
        </label>
      </div>
    </div>
  );
};

export default GeneralCheckbox;
